export const UPDATE_WORK_EXPERIENCE = '/workExperience/UPDATE'
export const UPDATE_COMPANY = '/company/UPDATE'
export const UPDATE_LOCATION = '/location/UPDATE'
export const UPDATE_POSITION = '/position/UPDATE'
export const UPDATE_TECHNOLOGY = '/technology/UPDATE'
export const UPDATE_CONTRACT_TYPE = '/contractType/UPDATE'
export const UPDATE_PROJECT = '/project/UPDATE'
